export default {
  addEmployee(state, payload) {
    state.employees.push(payload);
  },
  setEmployees(state, payload) {
    state.employees = payload;
  },

  deleteEmployee(state, payload) {
    state.employees = state.employees.filter(employee => employee.id !== payload);
  },

  setFetchTimestamp(state) {
    state.lastFetch = new Date().getTime();
  },
};
